<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <div class="grid-container" :style="blockStyle">
            <cms-block-renderer v-for="child in block.children" :key="child.id" @block-selected="selectBlock"
                                :block="child" :parent="block" :block-selection="blockSelection" :editable="editable"
                                class="grid-item" :style="{ '--col-span': child.mediaProxy.span }" />
        </div>
    </cms-block>
</template>

<script>
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

// cms-block-columns #hot-reload-debug
export default {
    name: `cms-block-columns`,
    components: {
        CmsBlockRenderer,
        CmsBlock
    },
    extends: CmsBlock,
    computed: {
        blockStyle() {
            return {
                "--list-item-spacing": this.block.mediaProxy.spacing,
                "--list-item-columns": this.block.mediaProxy.columns,
            };
        },
    }
}
</script>

<style lang="scss" scoped>
.cms-block-columns {
    --list-item-columns: 0;
    --list-item-spacing: 10px;

    .grid-container {
        display: grid;
        grid-template-columns: repeat(var(--list-item-columns), 1fr);
        grid-gap: var(--list-item-spacing);
    }

    .grid-item {
        grid-column: span var(--col-span, 1);
    }
}
</style>
